/** [English, Hindi] pairs for strings shared by the ops screens. */
export const sharedMessages = {
  'ops.title': ['Catalogue operations', 'सूचीकरण संचालन'],
  'ops.eyebrow': ['Catalogue', 'सूचीकरण'],
  'ops.yes': ['Yes', 'हाँ'],
  'ops.no': ['No', 'नहीं'],
  'ops.col.barcode': ['Barcode', 'बारकोड'],
  'ops.col.title': ['Title', 'शीर्षक'],
  'ops.col.callNumber': ['Call number', 'कॉल नंबर'],
  'ops.col.library': ['Library', 'पुस्तकालय'],
  'ops.col.location': ['Location', 'स्थान'],
  'ops.col.status': ['Status', 'स्थिति'],
  'ops.col.lost': ['Lost status', 'खोया स्थिति'],
  'ops.status.available': ['Available', 'उपलब्ध'],
  'ops.status.onLoan': ['On loan', 'ऋण पर'],
  'ops.status.lost': ['Lost', 'खोई हुई'],
  'ops.status.withdrawn': ['Withdrawn', 'हटाई गई'],
  'ops.status.damaged': ['Damaged', 'क्षतिग्रस्त'],
  'ops.status.notForLoan': ['Not for loan', 'ऋण के लिए नहीं'],
  'ops.status.inTransit': ['In transit', 'मार्ग में'],
  'ops.nfl.LOANABLE': ['Loanable', 'ऋण योग्य'],
  'ops.nfl.NOT_FOR_LOAN': ['Not for loan', 'ऋण के लिए नहीं'],
  'ops.nfl.REFERENCE_ONLY': ['Reference only', 'केवल संदर्भ'],
  'ops.nfl.STAFF_COLLECTION': ['Staff collection', 'कर्मचारी संग्रह'],
  'ops.nfl.ON_ORDER': ['On order', 'ऑर्डर पर'],
  'ops.nfl.IN_PROCESSING': ['In processing', 'प्रक्रिया में'],
  'ops.nfl.ON_DISPLAY': ['On display', 'प्रदर्शन पर'],
  'ops.lost.NONE': ['Not lost', 'खोई नहीं'],
  'ops.lost.LOST': ['Lost', 'खोई हुई'],
  'ops.lost.LONG_OVERDUE': ['Long overdue', 'बहुत विलंबित'],
  'ops.lost.LOST_AND_PAID': ['Lost and paid', 'खोई और भुगतान'],
  'ops.lost.MISSING_IN_INVENTORY': ['Missing in inventory', 'सूची में गायब'],
  'ops.lost.CLAIMED_RETURNED': ['Claimed returned', 'लौटाने का दावा'],
  'ops.pick.aria': ['How to choose items', 'वस्तुएँ चुनने का तरीका'],
  'ops.pick.mode.barcodes': ['Barcode list', 'बारकोड सूची'],
  'ops.pick.mode.search': ['Search', 'खोज'],
  'ops.pick.mode.shelf': ['Shelf range', 'शेल्फ सीमा'],
  'ops.pick.mode.list': ['From a list', 'सूची से'],
  'ops.pick.selected': ['{count} selected', '{count} चुनी गईं'],
  'ops.pick.barcodes.label': ['Barcodes', 'बारकोड'],
  'ops.pick.barcodes.hint': ['Paste one per line, or separate with commas or spaces. Duplicates are removed.', 'प्रति पंक्ति एक चिपकाएँ, या अल्पविराम/स्पेस से अलग करें। दोहराव हटा दिए जाते हैं।'],
  'ops.pick.barcodes.count': ['{count} barcodes', '{count} बारकोड'],
  'ops.pick.barcodes.dupes': ['{count} duplicates removed', '{count} दोहराव हटाए गए'],
  'ops.pick.barcodes.tooMany': ['At most {max} barcodes at once.', 'एक बार में अधिकतम {max} बारकोड।'],
  'ops.pick.search.table': ['Items found', 'मिली वस्तुएँ'],
  'ops.pick.search.q': ['Barcode, title or call number', 'बारकोड, शीर्षक या कॉल नंबर'],
  'ops.pick.search.anyStatus': ['Any status', 'कोई भी स्थिति'],
  'ops.pick.search.anyLibrary': ['All libraries', 'सभी पुस्तकालय'],
  'ops.pick.search.selectAll': ['Select all matching ({count})', 'सभी मिलान चुनें ({count})'],
  'ops.pick.search.emptyTitle': ['No items match', 'कोई वस्तु नहीं मिली'],
  'ops.pick.search.emptyBody': ['Try a different search or clear the filters.', 'दूसरी खोज आज़माएँ या फ़िल्टर हटाएँ।'],
  'ops.pick.shelf.library': ['Library', 'पुस्तकालय'],
  'ops.pick.shelf.from': ['Call number from', 'कॉल नंबर से'],
  'ops.pick.shelf.fromHint': ['A prefix such as 823 is enough.', '823 जैसा उपसर्ग पर्याप्त है।'],
  'ops.pick.shelf.to': ['Call number to', 'कॉल नंबर तक'],
  'ops.pick.shelf.run': ['Find items', 'वस्तुएँ खोजें'],
  'ops.pick.shelf.table': ['Items on the shelf range', 'शेल्फ सीमा की वस्तुएँ'],
  'ops.pick.shelf.truncated': ['Only the first {max} items are used. Narrow the range for the rest.', 'केवल पहली {max} वस्तुएँ ली गईं। शेष के लिए सीमा घटाएँ।'],
  'ops.pick.shelf.emptyTitle': ['Nothing in that range', 'उस सीमा में कुछ नहीं'],
  'ops.pick.shelf.emptyBody': ['Check the library and the call numbers.', 'पुस्तकालय और कॉल नंबर जाँचें।'],
  'ops.pick.list.label': ['Your lists', 'आपकी सूचियाँ'],
  'ops.pick.list.choose': ['Choose a list', 'सूची चुनें'],
  'ops.pick.list.load': ['Load items', 'वस्तुएँ लोड करें'],
  'ops.pick.list.table': ['Items in the list', 'सूची की वस्तुएँ'],
  'ops.pick.list.emptyTitle': ['No lists yet', 'अभी कोई सूची नहीं'],
  'ops.pick.list.emptyBody': ['Create a list from the catalogue, then print labels for it here.', 'सूचीकरण से एक सूची बनाएँ, फिर यहाँ उसके लेबल छापें।'],
  'ops.diff.empty': ['(empty)', '(खाली)'],
  'ops.err.title': ['Something went wrong', 'कुछ गलत हो गया'],
  'ops.err.generic': ['Something went wrong. Please try again.', 'कुछ गलत हो गया। कृपया फिर प्रयास करें।'],
  'ops.err.network': ['Cannot reach the server. Check your connection.', 'सर्वर तक नहीं पहुँच सके। कनेक्शन जाँचें।'],
  'ops.err.FORBIDDEN': ['You do not have permission to do this.', 'आपको यह करने की अनुमति नहीं है।'],
  'ops.err.NO_ITEMS_SELECTED': ['Choose at least one item first.', 'पहले कम से कम एक वस्तु चुनें।'],
  'ops.err.BATCH_TOO_LARGE': ['Too many items for one batch. Split it into smaller batches.', 'एक बैच के लिए बहुत अधिक वस्तुएँ। छोटे बैच में बाँटें।'],
  'ops.err.NOTHING_TO_CHANGE': ['Tick at least one field to change.', 'बदलने के लिए कम से कम एक फ़ील्ड चुनें।'],
  'ops.err.REF_NOT_FOUND': ['One of the chosen library, type, location or collection no longer exists. Reload and choose again.', 'चुना गया पुस्तकालय, प्रकार, स्थान या संग्रह अब मौजूद नहीं। पुनः लोड करके चुनें।'],
  'ops.err.SESSION_NOT_OPEN': ['This session is no longer open.', 'यह सत्र अब खुला नहीं है।'],
  'ops.err.SESSION_NOT_COMPLETED': ['Complete the session before marking missing items.', 'गायब वस्तुएँ चिह्नित करने से पहले सत्र पूरा करें।'],
  'ops.err.INVENTORY_RANGE_INVALID': ['The call number range is the wrong way round.', 'कॉल नंबर सीमा उल्टी है।'],
  'ops.reason.NOT_FOUND': ['Not found', 'नहीं मिली'],
  'ops.reason.ITEM_ON_LOAN': ['On loan', 'ऋण पर'],
  'ops.reason.ITEM_HAS_WAITING_HOLD': ['Waiting hold', 'प्रतीक्षारत होल्ड'],
  'ops.reason.ITEM_IN_TRANSIT': ['In transit', 'मार्ग में'],
  'ops.reason.UNKNOWN': ['Skipped', 'छोड़ी गई'],
} as const satisfies Record<string, readonly [string, string]>;
